module.exports = __webpack_public_path__ + "img/cb9-l-100.c3574e72.gif";